import * as React from "react";
import type { FieldPath, FieldValues } from "react-hook-form";

type FormItemContextValue = {
    id: string;
};

export const FormItemContext = React.createContext<FormItemContextValue>({} as FormItemContextValue);

type FormFieldContextValue<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = {
    name: TName;
};

export const FormFieldContext = React.createContext<FormFieldContextValue>({} as FormFieldContextValue);
